import React from "react";
import { Input } from "@skbkontur/react-ui";
import { MenuItem, Spinner } from "react-ui";

import { FiasAddressFields } from "../Types/FiasTypes";
import { extractSuggestFields, getItemAddressText } from "../Utils/utils";

import { StyledMenu } from "./SuggestList.styles";

interface DropDownListProps {
    inputRef: React.RefObject<Input>;
    fetchedAddresses: FiasAddressFields[];
    selectIndex: number;
    setSelectIndex: React.Dispatch<React.SetStateAction<number>>;
    submitAddressHandler: (address: FiasAddressFields) => void;
    dropDownPrefix?: React.ReactNode;
    loading: boolean;
}

export const SuggestList: React.FC<DropDownListProps> = props => {
    const getAddressesToItems = (): JSX.Element[] =>
        props.fetchedAddresses.map((suggestAddress, index) => {
            const focused = props.selectIndex === index;
            const { longText, shortText } = getItemAddressText(suggestAddress);
            const { fiasId } = extractSuggestFields(suggestAddress.suggest);
            return (
                <MenuItem
                    key={fiasId}
                    onMouseEnter={() => props.setSelectIndex(index)}
                    onMouseLeave={() => props.setSelectIndex(-1)}
                    onClick={() => props.submitAddressHandler(suggestAddress)}
                    comment={longText}
                    state={focused ? "hover" : null}>
                    {shortText}
                </MenuItem>
            );
        });

    const miniLoader = (
        <MenuItem disabled>
            <Spinner type="mini" caption={"Ищем подходящие адреса..."} />
        </MenuItem>
    );

    return (
        <StyledMenu>
            {props.loading ? miniLoader : getAddressesToItems()}
            {props.dropDownPrefix}
        </StyledMenu>
    );
};
